import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';

export const GeneralSettings = () => {

  const isMounted = useRef(false);
  const [loanPeriod, setLoanPeriod] = useState({ days: '' });
  const [settings, setSettings] = useState([]);
  const [modalFor, setModalFor] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [dataLoad, setDataLoad] = useState(false);

  const TabOptions = [
    { label: 'Inbound', value: 'Inbound' },
    { label: 'Planning', value: 'Planning' },
    { label: 'Export', value: 'Export' },
    { label: 'Import', value: 'Import' },
    { label: 'ShipmentRecords', value: 'ShipmentRecords' }
  ];
  const CentreOptions = [
    { label: 'Dnata', value: 'Dnata' }
  ];

  const [formData, setFormData] = useState({ tab: "ShipmentRecords" });
  const [pendingValue, setPendingValue] = useState(null);
  const [pendingKey, setPendingKey] = useState(null);
  const [showConfirmationM, setShowConfirmationM] = useState(false);




  // const fetchTab = async () => {
  //   try {
  //     const res = await withRFSToken.post('setting/rules-list', {setting_type : 'tab_preferences'});
  //     if (res.data.response_code === 200) {
  //       setSettings(res.data.response_data);
  //     } else {
  //       toast.error(res.data.response_msg);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }
  const fetchRule = async () => {
    try {
      const res = await withRFSToken.get('shipment/get-general-settings', {});
      if (res.data.response_code === 200) {
        setSettings(res.data.response_data);
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const fetchPref = async () => {
    try {
      const res = await withRFSToken.get('forwarder-user-setting/get-setting', {});
      if (res.data.response_code === 200) {
        const { tab_preferences, inspection_center } = res.data.response_data.settings || {};
        setFormData({ tab_preferences, inspection_center });
        setPendingValue(tab_preferences);
        if (tab_preferences) localStorage.setItem('FSTab', tab_preferences);
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    if (isMounted.current) return;
    fetchRule();
    fetchPref();
    isMounted.current = true;
  }, []);

  const handleChange = (key, value) => {
    if (value !== pendingValue || key !== pendingKey) {
      setPendingKey(key);
      setPendingValue(value);
      setShowConfirmationM(true);
    }
  };

  const handleConfirmTab = async (confirmed) => {
    if (confirmed) {
      const payload = pendingKey === 'inspection_center'
        ? { inspection_center: pendingValue }
        : { tab_preferences: pendingValue };

      try {
        const res = await withRFSToken.post('forwarder-user-setting/save-setting', { settings: payload });

        if (res.data.response_code === 200) {
          // setFormData(prev => ({ ...prev, tab: pendingValue }));
          fetchPref();
          toast.success('Preference updated successfully');
        } else {
          toast.error(res.data.response_msg || 'Failed to update tab preference');
        }
      } catch (error) {
        console.error('Error updating preference:', error);
        toast.error('Something went wrong while updating.');
      }
    }
    setPendingValue(null);
    setPendingKey(null);
    setShowConfirmationM(false);
  };

  const handleOnChange = (name, value) => {
    // const { name, value } = event.target;
    switchChange()
    // setFormData(prevData => ({
    //   ...prevData,
    //   [name]: value
    // }));
  }
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setLoanPeriod(prevData => ({
      ...prevData,
      [name]: value
    }));
  }

  const saveRule = async () => {
    try {
      const res = await withRFSToken.post('uld-settings/general-setting', { demurrage_days: loanPeriod.days });
      if (res.data.response_code === 200) {
        toast.success('Demurrage Days Successfully');
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const switchChange = (setting) => {
    setModalFor(setting);
    setShowConfirmation(true);
  };

  const handleConfirm = async (confirmed) => {
    if (confirmed && modalFor) {
      try {
        const res = await withRFSToken.post('shipment/save-org-general-setting', {
          status: modalFor.status === 1 ? 0 : 1,
          general_setting_id: modalFor.id,
        });
        if (res.data.response_code === 200) {
          setSettings(prev =>
            prev.map(s =>
              s.id === modalFor.id ? { ...s, status: s.status === 1 ? 0 : 1 } : s
            )
          );
          toast.success('Setting updated successfully');
        } else {
          toast.error(res.data.response_msg);
        }
      } catch (error) {
        console.error('Error updating setting:', error);
      }
    }
    setShowConfirmation(false);
    setModalFor(null);
  };

  const shpTab = localStorage.getItem('FSTab');
  const SBack = localStorage.getItem('SettingsBack');

  return (
    <>
      {console.log('fd', formData)}
      {/* <div className=""> */}
      {/* <Header logo_url={`/ForwarderShipments/${shpTab ? shpTab : 'ShipmentRecords'}`} /> */}
      {/* <Header
          logo_url={SBack ? SBack : `/ForwarderShipments/${shpTab ? shpTab : 'ShipmentRecords'}`}
          sBackUrl={SBack ? SBack : `/ForwarderShipments/${shpTab ? shpTab : 'ShipmentRecords'}`}
        /> */}
      {/* <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel">
            <div className="row">
              <LeftSettings /> */}
      <div className='col-9 col-xxl-9 stting_right'>
        <div className='settingbg_right'>
          <h4>General Settings</h4>
          <p>Set your notification preferences for when you are in or away from the dashboard.</p>
          <hr />
          {settings.map(setting => (
            <>
              <div className='d-flex align-items-center mt-3' key={setting.id}>
                <div className='me-3'>
                  <h4>{setting.name}</h4>
                  <p className='mb-0'>Enable {setting.name}</p>
                </div>
                {/* <div className='d-flex align-items-center st_days'>
                          <Form.Check
                            type="switch"
                            id={`switch-${setting.id}`}
                            label=""
                            onChange={() => switchChange(setting)}
                            checked={setting.status === 1}
                          />
                        </div> */}
                <div className="new_tgl me-3">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={setting.status === 1}
                      onChange={() => switchChange(setting)}
                      id={`switch-${setting.id}`}
                    />
                    <span className="slider-text">
                      <span className="off">
                        No <span className="circle"></span>
                      </span>
                      <span className="on">
                        Yes <span className="checkmark">✓</span>
                      </span>
                    </span>
                  </label>
                </div>
              </div>

            </>
          ))}

          <div className='d-flex align-items-center mt-3'>
            <div className='me-3'>
              <h4>User Preference Settings</h4>
              <p>Please select the tab you want to open.</p>
            </div>
            <div style={{ width: '200px' }}>
              <Select
                options={TabOptions}
                onChange={(selected) => handleChange("tab_preferences", selected ? selected.value : "")}
                placeholder="Tab Preference" className="rfs_autoslct" name="tab"
                value={TabOptions.find((option) => option.value == formData.tab_preferences) || null}
              />
            </div>
          </div>

          <div className='d-flex align-items-center mt-3'>
            <div className='me-3'>
              <h4>Inspection Center Settings</h4>
              <p>Please select the inspection center you want to open.</p>
            </div>
            <div style={{ width: '200px' }}>
              <Select
                options={CentreOptions}
                onChange={(selected) => handleChange("inspection_center", selected ? selected.value : "")}
                placeholder="Tab Preference" className="rfs_autoslct" name="tab"
                value={CentreOptions.find((option) => option.value == formData.inspection_center) || null}
              />
            </div>
          </div>

        </div>
      </div>
      {/* </div>
          </div>
        </div>
      </div> */}
      <Modal className='addfrom change_type' show={showConfirmation} onHide={() => setShowConfirmation(false)} centered>
        <Modal.Header closeButton />
        <Modal.Body>
          <h3>{modalFor?.name}</h3>
          <p>Are you sure you want to switch?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={() => handleConfirm(false)}>
              No
            </Button>
            <Button variant="primary" onClick={() => handleConfirm(true)}>
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal className='addfrom change_type' show={showConfirmationM} onHide={() => handleConfirmTab(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Change</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {pendingKey === 'inspection_center'
            ? <>Are you sure you want to change your inspection centre to <b>{pendingValue}</b>?</>
            : <>Are you sure you want to change your tab preference to <b>{pendingValue}</b>?</>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={() => handleConfirmTab(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={() => handleConfirmTab(true)}>
              Yes, Change
            </Button></div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default GeneralSettings;